/**
 * Formata documento (CPF/CNPJ) removendo caracteres especiais e convertendo para maiúsculas
 * @param {string} value - Valor do documento
 * @returns {string} Documento formatado
 */
export const formatDocument = (value) => {
  if (!value) return '';
  return String(value)
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '');
};
